import {Injectable} from '@angular/core';
import {HttpClient, HttpContext, HttpParams} from '@angular/common/http';
import {GfxStoreService} from './gfx.store.service';
import { HttpContextToken } from '@angular/common/http';
export const SKIP_SPINNER = new HttpContextToken<boolean>(() => false);
@Injectable({
    providedIn: 'root',
})
export class GfxHttpSrv {
    beUrl: any;

    constructor(
        private http: HttpClient,
        private store: GfxStoreService
    ) {
    }

    get(url, data?, paramsReady?) {
        let params;
        if (!paramsReady) {
            params = new HttpParams();
            if (data) {
                Object.keys(data).forEach(function (item) {
                    params = params.set(item, data[item]);
                });
            }
        } else {
            params = data;
        }

        return this.http.get<any>(url, {params});
    }

    getPathParams(url, id) {
        return this.http.get<any>(url + '/' + id);
    }

    post(url, data, customMsgConfig?: ICustomMsg) {
        if (customMsgConfig && customMsgConfig.show) {
            this.store.central_msg_success = customMsgConfig.msg;
        } else if (customMsgConfig) {
            this.store.central_msg_success = '';
        }

        return this.http.post<any>(url, data);
    }

    postWithOptions(
        url: string,
        data: any,
        customMsgConfig?: ICustomMsg,
        skipSpinner = false
    ) {
        if (customMsgConfig && customMsgConfig.show) {
            this.store.central_msg_success = customMsgConfig.msg;
        } else if (customMsgConfig) {
            this.store.central_msg_success = '';
        }

        return this.http.post<any>(url, data, {
            context: new HttpContext().set(SKIP_SPINNER, skipSpinner)
        });
    }

    put(url, data, customMsgConfig?: ICustomMsg) {
        if (customMsgConfig && customMsgConfig.show) {
            this.store.central_msg_success = customMsgConfig.msg;
        } else if (customMsgConfig) {
            this.store.central_msg_success = '';
        }

        return this.http.put<any>(url + '/' + data.id, data);
    }

    delete(url, id, customMsgConfig?: ICustomMsg) {
        if (customMsgConfig && customMsgConfig.show) {
            this.store.central_msg_success_del = customMsgConfig.msg;
        } else if (customMsgConfig) {
            this.store.central_msg_success_del = '';
        }

        return this.http.delete<any>(url + '/' + id);
    }

    save(url, data, customMsgConfig?: ICustomMsg) {
        if (data.id) {
            return this.put(url, data, customMsgConfig);
        } else {
            return this.post(url, data, customMsgConfig);
        }
    }

    // resend(absoluteUrl, method, data) {
    //     data.msgConfirmOk = true;
    //     let url = absoluteUrl.slice(
    //         absoluteUrl.indexOf(this.beUrl) + this.beUrl.length
    //     );
    //     if (method == 'POST') {
    //         this.post(url, data);
    //     } else if (method == 'PUT') {
    //         this.put(url, data);
    //     }
    // }
}

export interface ICustomMsg {
    show: boolean,
    msg?: string
}
